/** Words used on every screen: buttons, states, generic errors, the shell around the pages. */
export default {
  'common.cancel': 'Cancel',
  'common.done': 'Done',
  'common.close': 'Close',
  'common.save': 'Save',
  'common.saving': 'Saving…',
  'common.retry': 'Retry',
  'common.tryAgain': 'Try again',
  'common.loading': 'Loading…',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.page': 'Page {page} of {pages}',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.on': 'On',
  'common.off': 'Off',
  'common.all': 'All',
  'common.none': 'None',
  'common.search': 'Search',
  'common.apply': 'Apply',
  'common.remove': 'Remove',
  'common.edit': 'Edit',
  'common.add': 'Add',
  'common.confirm': 'Confirm',
  'common.optional': '(optional)',
  'common.required': 'Required',
  'common.dismiss': 'Dismiss message',
  'common.noAccess': 'No access',
  'common.error.generic': 'Something went wrong. Try again.',
  'common.error.network': 'The server could not be reached.',
  'common.error.unexpected': 'Unexpected error.',

  // the app shell (nav rail, account panel)
  'shell.skip': 'Skip to content',
  'shell.menu': 'Menu',
  'shell.openMenu': 'Open menu',
  'shell.closeMenu': 'Close menu',
  'shell.online': 'Online',
  'shell.offline': 'Offline',
  'shell.display': 'Display',
  'shell.signOut': 'Sign out',
  'shell.account': '{name}: {status}. Account, display and sign out',
  'shell.language': 'Language',
  'shell.noAccessTitle': 'You do not have access to {page}',
  'shell.noAccessBody': 'Your role does not include this screen. Ask the owner or an admin if you need it.',
  'shell.moduleOffTitle': '{page} is switched off',
  'shell.moduleOffBody': 'This business does not run this module. The platform operator can switch it on.',
  'shell.noAccessBack': 'Go to {page}',
  'nav.till': 'Till',
  'nav.products': 'Products',
  'nav.inventory': 'Inventory',
  'nav.purchasing': 'Purchasing',
  'nav.customers': 'Customers',
  'nav.collections': 'Collections',
  'nav.returns': 'Returns',
  'nav.import': 'Import',
  'nav.reports': 'Reports',
  'nav.admin': 'Admin',
  'nav.readiness': 'Readiness',
  'nav.platform': 'Platform',
  'role.admin': 'Admin',
  'role.manager': 'Manager',
  'role.cashier': 'Cashier',
  'role.superadmin': 'Superadmin',

  // theme controls
  'theme.label': 'Display theme',
  'theme.choice': 'Colour theme: {choice}. Activate to change.',
  'theme.title': 'Theme: {choice}',
  'theme.auto': 'Auto',
  'theme.light': 'Light',
  'theme.dark': 'Dark',
  'theme.brand': 'Brand colour',
  'theme.blue': 'Blue',
  'theme.green': 'Green',
  'theme.violet': 'Violet',
  'theme.highContrast': 'High contrast',

  // boot and crash screens
  'app.loading': 'Loading the till…',
  'app.crashed': 'This screen hit a problem',
  'app.crashedDetail': '{message} Reload to continue.',
  'app.reload': 'Reload',

  // sign in
  'login.store': 'Sahyadri Supermarket',
  'login.subtitle': 'Point of sale terminal',
  'login.heading': 'Sign in to start your shift',
  'login.username': 'Username',
  'login.password': 'Password',
  'login.terminal': 'Terminal',
  'login.terminalN': 'Terminal {n}',
  'login.demoAdmin': 'Everything',
  'login.demoManager': 'No cost data',
  'login.demoCashier': 'Till only',
  'login.submit': 'Sign in',
  'login.signingIn': 'Signing in…',
  'login.demo': 'Demo accounts (development only)',
} as const;
